import { PostSection } from "@/components/blog/PostSection";
import { PostHighlight } from "@/components/blog/PostHighlight";

export function GeminiSection() {
  return (
    <PostSection id="gemini-evoluciona" title="Gemini se reinventa: memoria portable e instrucciones permanentes">
      <p>
        Google no se ha quedado quieto. Mientras OpenAI presentaba GPT-5.5 y Apple abría iOS, el equipo
        de Gemini ha lanzado dos funciones que apuntan directamente al corazón de la fidelización del
        usuario: <strong>importar la memoria de otras IAs</strong> y aplicar
        <strong> instrucciones personalizadas permanentes</strong> en Google Docs.
      </p>

      <h3 id="memoria-portable" className="text-xl font-bold text-white mt-8 mb-4">
        Memoria portable entre IAs
      </h3>
      <p>
        Gemini permite ahora migrar a un solo clic todo lo que ChatGPT o Claude saben del usuario:
        preferencias, contexto profesional, proyectos en curso, tono de escritura, etc. Es una
        respuesta directa al efecto bloqueo (lock-in) que han construido OpenAI y Anthropic en los
        últimos dos años.
      </p>

      <PostHighlight type="warning">
        La portabilidad de la memoria de IA marca el inicio de una era similar a la portabilidad
        del número de teléfono: el usuario deja de ser rehén de su proveedor.
      </PostHighlight>

      <h3 id="gemini-docs" className="text-xl font-bold text-white mt-8 mb-4">
        Instrucciones permanentes en Google Docs
      </h3>
      <p>
        Desde el 5 de mayo de 2026, Gemini en Google Docs acepta hasta
        <strong> 1.000 caracteres de instrucciones personalizadas</strong> que se aplican
        automáticamente a todas las interacciones dentro del documento. Disponible para clientes
        Business, Enterprise y Education, permite definir tono, idioma, estructura y reglas de estilo
        una sola vez para todo el equipo. Para agencias y empresas que producen contenido a escala,
        es un avance enorme en consistencia editorial.
      </p>
    </PostSection>
  );
}
